import React, { useEffect, useState, useRef } from 'react'
import Api from '../../../../_helpers/Api'
import { useParams, useHistory } from 'react-router-dom'
import { trans } from '../../../../_providers/Translation'
import { buildSharedApiUrl, buildSharedApiData, addSharedParamsToFormData } from '../../../../_helpers/SharedParams'

//images
import deleteIcon from '../../../../assets/img/reservations/icons/delete.svg'
import imageIcon from '../../../../assets/img/icons/image.png'
import loader from '../../../../assets/img/loader.svg'
import notFound from '../../../../assets/img/not-found.png'
import uploadImage from "@/assets/img/reservations/icons/upload.svg"

//modals
import QuestionModal from '../../../modals/messages/Question'
import PreviewModal from './modals/Images'

function Images(props) {

    const [images, setImages] = useState({
        data: [],
        loading: true
    })

    const [imageSizeError, setImageSizeError] = useState(null)

    let params = useParams().id

    const history = useHistory()

    //refs
    const questionModalRef = useRef(null)
    const previewModalRef = useRef(null)

    useEffect(() => loadData(), [])

    const loadData = () => {
        setImages(images => ({
            ...images,
            loading: true,
        }))

        // Build API URL with shared parameters using utility
        const url = buildSharedApiUrl(`reservations/images?id=${params}`, props.sharedParams)

        Api.get(url)
            .then(res => {
                setImages(images => ({
                    ...images,
                    data: Array.isArray(res.data) ? res.data : [],
                    loading: false,
                }))
            })
            .catch(err => {
                console.error('Error loading images:', err)
                setImages(images => ({
                    ...images,
                    data: [],
                    loading: false,
                }))
            })
    }

    const handleDelete = id => questionModalRef.current.open(id)

    const handleAcceptDelete = id => {
        const baseData = {
            id: params,
            image_id: id,
        }

        // Use utility to add shared parameters
        const data = buildSharedApiData(baseData, props.sharedParams)

        Api.post('reservations/images/delete', data).then(() => {
            history.push(`?tab=images&indicator=${new Date().getTime()}`)
        })

        let newData = images.data.filter(image => {
            return image.id != id
        })

        setImages(images => ({
            ...images,
            data: newData
        }))
    }

    const handleFileSelect = e => {
        const files = Array.from(e.target.files)
        const maxSize = 1024 * 1024 // 1 MB

        const oversized = files.filter(f => f.size > maxSize)

        if (oversized.length) {
            setImageSizeError(trans('messages.imageSizeExceeded', { files: oversized.map(f => f.name).join(', ') }))
            e.target.value = ''
        } else {
            setImageSizeError(null)
            document.querySelector('.upload-btn button').click()
        }
    }

    const handleUpload = e => {
        e.preventDefault()

        let formData = new FormData(e.target)

        // Use helper to add shared parameters to FormData
        formData = addSharedParamsToFormData(formData, props.sharedParams)

        Api.post('reservations/images/add', formData, {
            headers: {
                'content-type': 'multipart/form-data'
            }
        }).then(() => {
            history.push(`?tab=images&indicator=${new Date().getTime()}`)
            loadData()
        })

    }

    const preview = index => {
        previewModalRef.current.show(index)
    }

    return (
        <div id='reservation-images'>
            <QuestionModal
                mainMessage={trans('headings.question4')}
                secondaryMessage={trans('subheadings.confirmDelete')}
                ref={questionModalRef}
                callback={handleAcceptDelete}
            />

            <PreviewModal
                ref={previewModalRef}
                images={images.data}
            />

            <div className='pannel'>
                {imageSizeError && (
                    <div className="alert danger" style={{ marginBottom: '10px' }}>
                        {imageSizeError}
                    </div>
                )}
                <div className='upload-images'>
                    {images.loading ?
                        <img src={loader} alt="loading" />
                        :
                        (images.data || []).length ? (
                            <div className="images-grid">
                                {(images.data || []).map((image, i) => (
                                    <div key={image.id} className="image-item">
                                        <button
                                            type="button"
                                            className="delete-btn"
                                            onClick={() => handleDelete(image.id)}
                                        >
                                            <img src={deleteIcon} alt="Delete" />
                                        </button>
                                        <div className="image-preview">
                                            <img
                                                src={image.picture}
                                                alt={image.id}
                                                onClick={e => preview(i)}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <></>
                        )}
                    <form onSubmit={handleUpload}
                        className="upload-btn"
                        disabled={props.data.can_modify}
                    >
                        <img src={uploadImage} alt="Upload" />
                        <button type='submit' />
                        <input type="hidden" name="id" value={params} />
                        <input type="file" id="files" name="images[]" multiple onChange={handleFileSelect} />
                        <div>
                            <div className="upload-title">{trans('labels.attachImages')}</div>
                            <div className="upload-subtitle">
                                {trans('labels.allowedImageFormats')}
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Images